import { ActivatedRouteSnapshot, CanActivateFn, Router, RouterStateSnapshot } from '@angular/router';
import { inject } from '@angular/core';
import { Location } from '@angular/common';

import { RootPaths } from '@fcom/core';
import { urlQueryString, urlWithoutQueryString } from '@fcom/core/utils/app-url-utils';
import { MANAGE_BOOKING_STEPS } from '@fcom/common-booking/manage-booking-config';

/**
 * In order to resolve two different component under the same path, we use a can activate function with a internal navigation to render option 1 or 2
 */
export const checkInOrMmb: CanActivateFn = (_route: ActivatedRouteSnapshot, state: RouterStateSnapshot) => {
  const paths = state.url.split('/');
  if (paths[2] && urlWithoutQueryString(paths[2]) === RootPaths.CHECK_IN_ROOT) {
    const language = paths[1];
    const queryParams = urlQueryString(state.url);
    const search = queryParams ? `?${queryParams}` : '';
    inject(Location).replaceState(`/${language}/${RootPaths.CHECK_IN_ROOT}${search}`);
    inject(Router).navigateByUrl(
      `/${language}/${RootPaths.MANAGE_BOOKING_ROOT}/${MANAGE_BOOKING_STEPS.CHECK_IN.path}${search}`,
      { skipLocationChange: true }
    );
    return true;
  }
  return true;
};
